import { render } from "./AudienceIncludeExclude.vue?vue&type=template&id=8f67d646"
import script from "./AudienceIncludeExclude.vue?vue&type=script&lang=js"
export * from "./AudienceIncludeExclude.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__